export function showConversationalError({ block = {}, state = {} }) {
	if (block.typeName === 'email' && block?.properties?.business_only && state.isLoading) {
		return state.errorReason !== 'business_email_invalid';
	}

	return state.showError && state.inputSet;
}
